module.exports = __webpack_public_path__ + "static/media/alert-healt-flags.f4f0d6d9.svg";